export default "__VITE_ASSET__f13e6aa8__"